export enum TimeframeOptions {
  None,
  CurrentPayroll,
  MonthToDate,
  QuarterToDate,
  YearToDate,
  DateRange
}

export enum GroupbyOptionsLaborSummary {
  Number,
  Name
}
